import { AlgoliaStoreData } from '@jbhi-fi/apis/src/algolia/types/AlgoliaStoreData';
import { getTitleCase } from '@jbhi-fi/utils/src/getTitleCase/getTitleCase';
import { getDistance, getStoreLink } from '../../utils/location/locationHelper';
import { AlgoliaLocationData, AlgoliaLocationResponse, Coordinates } from './types';

export const parseAlgoliaLocationData = (results: Array<AlgoliaLocationData>): Array<AlgoliaLocationResponse> => {
  return results.map(location => {
    return <AlgoliaLocationResponse>{
      displayName: `${getTitleCase(location.locality)}, ${location.state} ${location.postcode}`,
      suburb: getTitleCase(location.locality),
      postcode: location.postcode,
      state: location.state,
      hasCoordinates: location.hasCoordinates,
      coordinates: {
        longitude: location._geoloc.lng,
        latitude: location._geoloc.lat,
      },
    };
  });
};

const getStorePhone = (store: AlgoliaStoreData): string => {
  return store.locationType === 'Home' || store.locationType === 'Store' ? store.phone : '';
};

export const parseAlgoliaStoresData = (
  results: Array<AlgoliaStoreData>,
  currentLocation?: Coordinates
): Array<AlgoliaStoreData> => {
  const newLocations = results.map(location => {
    location.storeAddress.Suburb = getTitleCase(location.storeAddress.Suburb);
    location.phone = getStorePhone(location);
    location.url = getStoreLink(location.storeName);
    location.distance = `${getDistance(currentLocation, location._geoloc)}km`;
    return location;
  });
  return newLocations;
};
